import { deleteContainerAsync, deleteHeaderAsync, getAllHeadersInfoAsync, getHeaderInfoAsync, setHeaderInfoAsync, isMigrationCompleteAsync, } from "../../externalApi/HeaderStorageApi";
export class HeaderStorageApi {
    async deleteContainerAsync(storageContainer) {
        await deleteContainerAsync(storageContainer);
    }
    async deleteHeaderAsync(storageContainer, storageKey) {
        await deleteHeaderAsync(storageContainer, storageKey);
    }
    async isMigrationCompleteAsync(storageKey) {
        return await isMigrationCompleteAsync(storageKey);
    }
    async getAllHeadersInfoAsync(storageContainer) {
        return await getAllHeadersInfoAsync(storageContainer);
    }
    async getHeaderInfoAsync(storageContainer, storageKey) {
        return await getHeaderInfoAsync(storageContainer, storageKey);
    }
    async setHeaderInfoAsync(storageContainer, storageKey, value) {
        await setHeaderInfoAsync(storageContainer, storageKey, value);
    }
}
